import {
  GET_ORDERS_LIST_REQUEST,
  GET_ORDERS_LIST_SUCCESS,
  GET_ORDERS_LIST_FAILURE,
  GET_CURRENT_MONTH_ORDERS_OVERVIEW_REQUEST,
  GET_CURRENT_MONTH_ORDERS_OVERVIEW_SUCCESS,
  GET_CURRENT_MONTH_ORDERS_OVERVIEW_FAILURE,
  GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_REQUEST,
  GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_SUCCESS,
  GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_FAILURE,
  GET_ORDERS_ACHIEVEMENT_REQUEST,
  GET_ORDERS_ACHIEVEMENT_SUCCESS,
  GET_ORDERS_ACHIEVEMENT_FAILURE,
  GET_ORDERS_OVERVIEW_REQUEST,
  GET_ORDERS_OVERVIEW_SUCCESS,
  GET_ORDERS_OVERVIEW_FAILURE,
  LOG_OUT_SUCCESS,
  INITIALIZE_MESSAGE,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';
import { formatErrorMessage } from '../../utils/utils'
const { OrderedMap } = require('immutable')

const initialState = {
  pageInfo: {},
  orderList: OrderedMap({}),
  isLoading: false,
  currentMonthOrdersOverview: {},
  isLoadingCurrentMonthOrdersOverview: false,
  selectYearMonthOrdersOverview: {},
  isLoadingSelectYearMonthOrdersOverview: false,
  message: '',
  errorMessage: '',
  overview: {},
  isLoadingOverview: false,
  achievement: {},
  isLoadingAchievement: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ORDERS_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        message: '',
        errorMessage: '',
        orderList: action.payload.overwrite ? OrderedMap({}) : state.orderList,
        pageInfo: action.payload.overwrite ? {} : state.pageInfo,
      }
    case GET_ORDERS_LIST_SUCCESS: {
      let list = action.payload.overwrite ? OrderedMap({}) : state.orderList;
      action.payload.data.forEach(item => {
        list = list.set(item.id, item);
      })
      return {
        ...state,
        isLoading: false,
        message: '',
        errorMessage: '',
        orderList: list,
        pageInfo: action.payload.pageInfo,
      }
    }
    case GET_ORDERS_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        message: '',
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
      }
    case GET_CURRENT_MONTH_ORDERS_OVERVIEW_REQUEST:
      return {
        ...state,
        isLoadingCurrentMonthOrdersOverview: true,
      }
    case GET_CURRENT_MONTH_ORDERS_OVERVIEW_SUCCESS:
      return {
        ...state,
        isLoadingCurrentMonthOrdersOverview: false,
        currentMonthOrdersOverview: action.payload.overview,
      }
    case GET_CURRENT_MONTH_ORDERS_OVERVIEW_FAILURE:
      return {
        ...state,
        isLoadingCurrentMonthOrdersOverview: false,
      }
    case GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_REQUEST:
      return {
        ...state,
        isLoadingSelectYearMonthOrdersOverview: true,
      }
    case GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_SUCCESS:
      return {
        ...state,
        isLoadingSelectYearMonthOrdersOverview: false,
        selectYearMonthOrdersOverview: action.payload.overview,
      }
    case GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_FAILURE:
      return {
        ...state,
        isLoadingSelectYearMonthOrdersOverview: false,
      }
    case GET_ORDERS_ACHIEVEMENT_REQUEST:
      return {
        ...state,
        isLoadingAchievement: true,
      }
    case GET_ORDERS_ACHIEVEMENT_SUCCESS:
      return {
        ...state,
        isLoadingAchievement: false,
        achievement: action.payload.overview,
      }
    case GET_ORDERS_ACHIEVEMENT_FAILURE:
      return {
        ...state,
        isLoadingAchievement: false,
      }
    case GET_ORDERS_OVERVIEW_REQUEST:
      return {
        ...state,
        isLoadingOverview: true,
      }
    case GET_ORDERS_OVERVIEW_SUCCESS:
      return {
        ...state,
        isLoadingOverview: false,
        overview: action.payload.overview,
      }
    case GET_ORDERS_OVERVIEW_FAILURE:
      return {
        ...state,
        isLoadingOverview: false,
      }
    case LOG_OUT_SUCCESS:
      return initialState;
    case INITIALIZE_MESSAGE:
      return {
        ...state,
        message: initialState.message,
        errorMessage: initialState.errorMessage,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/orderList.js